import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, inr } from "@/lib/api";
import { RestaurantLayout } from "@/components/tabdine/RestaurantLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus, Trash2 } from "lucide-react";

export default function CustomCharges() {
  const [rows, setRows] = useState([]);
  const [f, setF] = useState({ name: "", charge_type: "fixed", value: 0, is_enabled: true });

  const load = () => api.get("/restaurant/charges").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!f.name.trim()) return toast.error("Name required");
    if (!Number(f.value) && Number(f.value) !== 0) return toast.error("Enter a value");
    try {
      await api.post("/restaurant/charges", { ...f, value: parseFloat(f.value) });
      setF({ name: "", charge_type: "fixed", value: 0, is_enabled: true });
      toast.success("Charge added");
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed");
    }
  };
  const toggle = async (c) => {
    await api.patch(`/restaurant/charges/${c.id}`, { is_enabled: !c.is_enabled });
    load();
  };
  const remove = async (c) => {
    if (!confirm(`Delete charge "${c.name}"?`)) return;
    await api.delete(`/restaurant/charges/${c.id}`);
    load();
  };

  return (
    <RestaurantLayout>
      <div className="p-4 lg:p-8 max-w-3xl">
        <h1 className="font-heading text-2xl font-bold text-brand-dark mb-1">Custom Charges</h1>
        <p className="text-brand-dark/60 text-sm mb-4">
          Add fees like Packing, Service, or Delivery. Enabled charges auto-apply to every bill and invoice.
        </p>

        <div className="bg-white rounded-xl border border-brand-dark/5 p-4 mb-4">
          <div className="text-xs uppercase tracking-widest text-brand-dark/50 mb-2">Add new charge</div>
          <div className="grid grid-cols-1 sm:grid-cols-5 gap-2">
            <Input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Name (e.g. Packing)" className="sm:col-span-2" data-testid="charge-name" />
            <select value={f.charge_type} onChange={(e) => setF({ ...f, charge_type: e.target.value })} className="h-10 rounded border border-input px-2 text-sm" data-testid="charge-type">
              <option value="fixed">Fixed ₹</option>
              <option value="percentage">Percentage %</option>
            </select>
            <Input type="number" value={f.value} onChange={(e) => setF({ ...f, value: e.target.value })} placeholder="Value" data-testid="charge-value" />
            <Button onClick={add} className="bg-brand-orange text-white" data-testid="charge-add"><Plus size={14} className="mr-1" /> Add</Button>
          </div>
        </div>

        <div className="space-y-2">
          {rows.length === 0 && <div className="text-brand-dark/60 text-sm py-6 text-center">No charges configured yet.</div>}
          {rows.map((c) => (
            <div key={c.id} className="bg-white rounded-lg border border-brand-dark/5 p-3 flex items-center gap-3" data-testid={`charge-row-${c.id}`}>
              <div className="flex-1">
                <div className="font-medium text-brand-dark">{c.name}</div>
                <div className="text-xs text-brand-dark/60">
                  {c.charge_type === "percentage" ? `${c.value}%` : inr(c.value)}
                </div>
              </div>
              <button
                onClick={() => toggle(c)}
                data-testid={`charge-toggle-${c.id}`}
                className={`text-xs px-3 py-1 rounded-full ${c.is_enabled ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-500"}`}
              >
                {c.is_enabled ? "Enabled" : "Disabled"}
              </button>
              <button onClick={() => remove(c)} className="text-red-500 hover:text-red-700" data-testid={`charge-del-${c.id}`}><Trash2 size={14} /></button>
            </div>
          ))}
        </div>
      </div>
    </RestaurantLayout>
  );
}
